import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { isNativeAndroid, isNativeIOS } from 'srcReact/helpers/utils'
import styles from './styles.module.scss'
import LinkButton from 'srcReact/components/common2/LinkButton'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import dayjs from 'dayjs'

function UpdateApp() {
  const { t } = useTranslation()

  const {
    common: { forceUpdateUptoAppVersion, appVersion }
  } = useSelector((state) => state)

  const handleUpdateLater = (e) => {
    localStorage.setItem('last_update_app_date', JSON.stringify(dayjs()))
  }

  return (
    <div className={styles.updateContainer}>
      <img className={styles.picture} src={config.assetUrl + '/images/bg-update-app.png'} />
      <h1 className={styles.title}>{t('common.update_app.title')}</h1>
      <p className={styles.description}>
        {(isNativeAndroid() && appVersion >= forceUpdateUptoAppVersion.android) ||
        (isNativeIOS() && appVersion >= forceUpdateUptoAppVersion.ios)
          ? t('common.update_app.text')
          : t('common.update_app.force_text')}
      </p>
      <LinkButton
        size='large'
        reactLink={false}
        href={
          !isNativeAndroid()
            ? 'https://apps.apple.com/us/app/mixr-community-is-everything/id1481064436'
            : 'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.mixr'
        }
        customStyle={styles.btnUpdate}
        text={t('common.update_app.button')}
      />
      {((isNativeAndroid() && appVersion >= forceUpdateUptoAppVersion.android) ||
        (isNativeIOS() && appVersion >= forceUpdateUptoAppVersion.ios)) && (
        <AnchorLink
          handleClick={handleUpdateLater}
          path={`/0/${appConstantSettings.DEFAULT_HOMEPAGE}`}
          className={styles.btnUpdateLater}>
          {t('common.update_app.update_later')}
        </AnchorLink>
      )}
    </div>
  )
}

export default UpdateApp
